var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToFeed = function SvgToFeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.18.68c.898 0 1.64.742 1.64 1.64v13.36a1.65 1.65 0 0 1-1.64 1.64H1.82a1.65 1.65 0 0 1-1.64-1.64V2.32C.18 1.422.922.68 1.82.68zm-10 15v-3.36H1.82v2.5c0 .47.39.86.86.86zm0-5V7.32H1.82v3.36zm0-5V2.32h-2.5c-.47 0-.86.39-.86.86v2.5zm5 10v-3.36H6.82v3.36zm0-5V7.32H6.82v3.36zm0-5V2.32H6.82v3.36zm4.14 10c.47 0 .86-.39.86-.86v-2.5h-3.36v3.36zm.86-5V7.32h-3.36v3.36zm0-5v-2.5c0-.47-.39-.86-.86-.86h-2.5v3.36z"
  })));
};
export default SvgToFeed;